import { colors } from '@ajaibid/components';

/**
 * @param {number} value The value to be checked
 * @returns {{color: string, icon: 'triangle-up'|'triangle-down'|'dash'}}
 */
export function getTickerStyle(value) {
  switch (true) {
    case value > 0:
      return { color: colors.GREEN_5, icon: 'triangle-up' };
    case value < 0:
      return { color: colors.RED_5, icon: 'triangle-down' };
    case value === 0:
    default:
      return { color: colors.NEUTRAL_5, icon: 'dash' };
  }
}
